import { Component, OnInit } from '@angular/core';
import { CommonModule } from '@angular/common';
import { TranslatePipe } from '@ngx-translate/core';
import { Store } from '@ngxs/store';
import { AuthService } from 'src/app/pages/login/service/auth.service';
import { Router } from '@angular/router';

@Component({
  selector: 'app-notifications',
  standalone: true,
  imports: [CommonModule, TranslatePipe],
  templateUrl: './notifications.component.html',
  styleUrls: ['./notifications.component.scss'],
})
export class NotificationsComponent implements OnInit {
  notificationCount: number = 4; // Número de notificaciones (estático por ahora)
  userName: string = '';

  constructor(
    private store: Store,
    private authService: AuthService,
    private router: Router
  ) {}

  ngOnInit() {
    const user = this.authService.getCurrentUser();
    this.userName = user ? user.username : 'Invitado'; // Evita errores si no hay usuario
  }

  public logout() {
    //this.authService.logout();
    // this.router.navigate(['/login']);

    try {
      this.authService.logout();
      this.router.navigate(['/login']);
    } catch (error) {
      console.error('Error al cerrar sesión:', error);
      this.router.navigate(['/login']);
    }
  }
}
